import {
  CallableInput,
  CallableToggle,
  CountrySelect,
} from "Components/Shared";
import PresentationSelect from "Components/Shared/PresentationSelect";
import { Field, Formik } from "formik";
import { useAccount, useDevice } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import React, { Fragment } from "react";
import { Button, Form } from "semantic-ui-react";

type EndpointProps = {
  fieldName: string;
};
const EndpointForm = ({ fieldName }: EndpointProps) => {
  const { device, update } = useDevice();
  const { account } = useAccount();

  if (!device || !account) return <Fragment />;

  return (
    <Formik
      initialValues={device}
      //   validationSchema={DeviceSchema}
      onSubmit={(values, actions) => {
        update(values);
      }}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          <Field
            name={`${fieldName}.ringTime`}
            label='Ring Time (s)'
            type='number'
            min='12'
            max='180'
            component={CallableInput}
          />

          <Field
            name={`${fieldName}.maxCallTime`}
            label='Max Call Time (s)'
            type='number'
            min='60'
            max='14400'
            component={CallableInput}
          />

          <CountrySelect
            name={`${fieldName}.countryCode`}
            label='Select Country'
          />

          <PresentationSelect
            name={`${fieldName}.present`}
            label='Inbound Presentation'
          />

          <Field
            toggle
            name={`${fieldName}.record`}
            label='Record'
            component={CallableToggle}
          />

          <Button primary type='submit' disabled={!isEmpty(props.errors)}>
            Update
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default EndpointForm;
